// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"12":"profiler","777":"recorder"}[chunkId] + "." + {"12":"dfbd54465cb94b1bdcfc","777":"fd1b7f53247fe52fc3e3"}[chunkId] + ".bundle.js";
};